import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Gift } from 'lucide-react';
import { clubsService } from '../../../../services';
import StateCard from '../../../../platform/components/feedback/StateCard';
import { getClubPublicPath } from '../../../../utils/clubPublicPaths';

const filters = [
    { key: 'All', label: 'All' },
    { key: 'Public', label: 'Public' },
    { key: 'Members', label: 'Members' },
    { key: 'Premium', label: 'Premium' }
];

const LatestVenuePerks = () => {
    const [offers, setOffers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [audienceFilter, setAudienceFilter] = useState('All');

    useEffect(() => {
        const fetchOffers = async () => {
            setIsLoading(true);
            try {
                const params = new URLSearchParams();
                params.append('take', '8');
                params.append('audience', audienceFilter);
                const data = await clubsService.getLatestOffers(params);
                setOffers(data || []);
            } catch (error) {
                console.error('Failed to load latest venue offers:', error);
                setOffers([]);
            } finally {
                setIsLoading(false);
            }
        };

        fetchOffers();
    }, [audienceFilter]);

    const visibleOffers = useMemo(() => offers.slice(0, 4), [offers]);

    return (
        <div className="home-latest-perks">
            <div className="home-latest-perks-heading">
                <h5>Latest Venue Perks</h5>
                <Link to="/dashboard/connect-perks" state={{ fromDashboard: true, from: '/dashboard/home' }}>
                    Browse Connect Perks
                    <ArrowRight size={14} />
                </Link>
            </div>
            <p className="home-latest-perks-helper">
                Show your Connect Pass QR at the venue to claim eligible perks.
            </p>

            <div className="home-latest-perks-filters">
                {filters.map((filter) => (
                    <button
                        type="button"
                        key={filter.key}
                        className={audienceFilter === filter.key ? 'active' : ''}
                        onClick={() => setAudienceFilter(filter.key)}
                    >
                        {filter.label}
                    </button>
                ))}
            </div>

            {isLoading ? (
                <StateCard
                    icon={Gift}
                    title="Loading venue perks"
                    description="Finding the latest offers from nearby and active venues."
                    compact
                    loading
                />
            ) : visibleOffers.length === 0 ? (
                <StateCard
                    icon={Gift}
                    title="No live perks right now"
                    description="Venue offers will appear here as soon as clubs publish them."
                    compact
                />
            ) : (
                <div className="home-latest-perks-list">
                    {visibleOffers.map((offer) => (
                        <Link key={offer.clubOfferId} to={getClubPublicPath(offer)} className="home-latest-perks-item">
                            <div className="home-latest-perks-item-top">
                                <strong>{offer.title}</strong>
                                {offer.isFeatured ? <span>Featured</span> : null}
                            </div>
                            <p>{offer.shortDescription || offer.fullDescription || 'Venue perk available now.'}</p>
                            <div className="home-latest-perks-item-meta">
                                <em>{offer.clubName}</em>
                                <small>{offer.audience || 'Public'}</small>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LatestVenuePerks;
